import React, { useEffect, useState } from "react";
import { TextField, FormControl, Alert } from "@mui/material";
import axios from "axios";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { getInputProps, getInputLabelProps } from "../../../common/appStyles";
import Combobox from "../../../components/common/Combobox";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";

export default function AddWorkflow({ model, setModel }) {
  const { config, STATUS_ENDPOINT } = useGlobalContext();
  const [statusList, setStatusList] = useState(null);
  const [descriptionCount, setDescriptionCount] = useState(0);
  const [statusData, setStatusData] = useState(null);
  const maximumCharactersForDescription =
    MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  const getEventStatus = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(`${STATUS_ENDPOINT}/initial`, requestConfig);

    setStatusData(data?.data);
  };

  useEffect(() => {
    getEventStatus();
  }, []);

  useEffect(() => {
    if (model?.Description) {
      setDescriptionCount(model?.Description.length);
    }
  }, [model?.Description]);

  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  const handleInitialStatusChange = (selectedStatus) => {
    if (selectedStatus) {
      setModel({
        ...model,
        InitialStatusId: selectedStatus?.Id ?? 0,
      });
    }
  };

  useEffect(() => {
    if (statusData && statusData.Ok && statusData?.Data?.length > 0) {
      setStatusList(statusData.Data);
    }
  }, [statusData]);

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full">
        <div className="flex flex-wrap mb-3">
          <div className="w-full mt-2">
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Name"
              label={localize.name}
              variant="outlined"
              onChange={handleChange}
              value={model?.Name}
            />
          </div>
        </div>

        <div className="w-full flex flex-wrap mb-3">
          <Alert severity="info" className="w-full">
            <label className="text-xs">
              {localize.initial_status_selection_info}
            </label>
          </Alert>
        </div>

        <div className="flex flex-wrap mb-3">
          <div className="w-full">
            <FormControl required fullWidth>
              <Combobox
                isRequired
                id="InitialStatus"
                handleValueChange={handleInitialStatusChange}
                fieldLabel={localize.initial_status}
                fieldOptions={statusList ?? []}
                fieldValue={model?.StatusId}
              />
            </FormControl>
          </div>
        </div>

        <div className="flex flex-wrap mb-3">
          <div className="w-full">
            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              multiline
              rows={5}
              id="outlined-basic"
              name="Description"
              label={localize.description}
              variant="outlined"
              onChange={handleChange}
              value={model?.Description}
              helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
